export default __webpack_public_path__ + "static/media/logoLottie.e726fdb0.png";